import { Component, Vue } from 'vue-property-decorator';

export enum Font {
  POPPINS = 'poppins',
  PT_MONO = 'mono',
  RUBIK = 'rubik',
  PLAYFAIR = 'playfair',
  MERRIWEATHER = 'merriweather',
}

@Component
export class FontMixin extends Vue {
  $getFontFamily(font: Font) {
    switch (font) {
      case Font.PT_MONO: {
        return '"PT Mono", monospace';
      }
      case Font.POPPINS: {
        return '"Poppins", sans-serif';
      }
      case Font.PLAYFAIR: {
        return '"Playfair Display", serif';
      }
      case Font.MERRIWEATHER: {
        return '"Merriweather", serif';
      }
      case Font.RUBIK: {
        return '"Rubik", sans-serif';
      }
      default: {
        return '';
      }
    }
  }
}
